import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ProductionDetails = lazy(() => import("@/pages/ProductionDetails"));

export const Route = createFileRoute("/produktionsstatus")({
  head: () => seoHead("/produktionsstatus"),
  component: () => <ProductionDetails />,
});
